"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 *
 * @class Me
 * @classdesc
 */
var Me = /** @class */ (function () {
    function Me(recover) {
        var _this = this;
        this.recover = recover;
        /**
         *
         *
         * @memberof Me
         */
        this.get = function () {
            return _this.recover.request("/me", "GET", null, null);
        };
        /**
         *
         *
         * @memberof Me
         */
        this.edit = function (userChanges) {
            return _this.recover.request("/me", "PUT", userChanges, null);
        };
        this.setJoyrideOn = function () {
            return _this.recover.request("/me/joyride/on", "PUT", null, null);
        };
        this.setJoyrideOff = function (changes) {
            return _this.recover.request("/me/joyride/off", "PUT", null, null);
        };
    }
    return Me;
}());
exports.default = Me;
